export default __webpack_public_path__ + "static/ph_liner_2_river-853d914c297e3133698dffd84b67e8a4.jpeg";